export default __webpack_public_path__ + "static/apparel-20da680a8294870878bb1111bcb5cd67.webp";